import React from 'react';
import HomeComponent from '../../../components/home'
function home(){
  return(
    <HomeComponent></HomeComponent>
  )
}

export default home;